var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 8.68359V9.48359C4.6875 10.5886 6.99609 11.4836 9.84375 11.4836C12.6914 11.4836 15 10.5886 15 9.48359V8.68359H4.6875Z",
    fill: "#FFBA07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 10.6836C12.6915 10.6836 15 9.78816 15 8.68359C15 7.57902 12.6915 6.68359 9.84375 6.68359C6.99603 6.68359 4.6875 7.57902 4.6875 8.68359C4.6875 9.78816 6.99603 10.6836 9.84375 10.6836Z",
    fill: "#FFCB45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.2271V11.0272C13.4824 10.9122 13.7959 10.7797 14.0625 10.6321V9.88464H13.96C13.7168 10.0121 13.4385 10.1271 13.125 10.2271Z",
    fill: "#FFDF8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.6073V11.4073C11.5781 11.3723 11.8916 11.3223 12.1875 11.2648V10.4648C11.8916 10.5248 11.5781 10.5723 11.25 10.6073Z",
    fill: "#FFDF8E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 7.08398V7.88398C4.6875 8.98898 6.99609 9.88398 9.84375 9.88398C12.6914 9.88398 15 8.98898 15 7.88398V7.08398H4.6875Z",
    fill: "#FFBA07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 9.08398C12.6915 9.08398 15 8.18855 15 7.08398C15 5.97941 12.6915 5.08398 9.84375 5.08398C6.99603 5.08398 4.6875 5.97941 4.6875 7.08398C4.6875 8.18855 6.99603 9.08398 9.84375 9.08398Z",
    fill: "#FFCB45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 8.62583V9.42585C13.4824 9.31085 13.7959 9.17834 14.0625 9.03084V8.28333H13.96C13.7168 8.41083 13.4385 8.52583 13.125 8.62583Z",
    fill: "#FFDF8E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.00578V9.80578C11.5781 9.77078 11.8916 9.72078 12.1875 9.66328V8.86328C11.8916 8.92328 11.5781 8.97078 11.25 9.00578Z",
    fill: "#FFDF8E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 5.48242V6.28242C4.6875 7.38742 6.99609 8.28242 9.84375 8.28242C12.6914 8.28242 15 7.38742 15 6.28242V5.48242H4.6875Z",
    fill: "#FFBA07"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 7.48242C12.6915 7.48242 15 6.58699 15 5.48242C15 4.37785 12.6915 3.48242 9.84375 3.48242C6.99603 3.48242 4.6875 4.37785 4.6875 5.48242C4.6875 6.58699 6.99603 7.48242 9.84375 7.48242Z",
    fill: "#FFCB45"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.02622V7.82622C13.4824 7.71122 13.7959 7.57872 14.0625 7.43122V6.68372H13.96C13.7168 6.81122 13.4385 6.92622 13.125 7.02622Z",
    fill: "#FFDF8E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.40617V8.20617C11.5781 8.17117 11.8916 8.12117 12.1875 8.06367V7.26367C11.8916 7.32367 11.5781 7.37117 11.25 7.40617Z",
    fill: "#FFDF8E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 3.88281V4.68281C4.6875 5.78781 6.99609 6.68282 9.84375 6.68282C12.6914 6.68282 15 5.78781 15 4.68281V3.88281H4.6875Z",
    fill: "#FFBA07"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 5.88281C12.6915 5.88281 15 4.98738 15 3.88281C15 2.77824 12.6915 1.88281 9.84375 1.88281C6.99603 1.88281 4.6875 2.77824 4.6875 3.88281C4.6875 4.98738 6.99603 5.88281 9.84375 5.88281Z",
    fill: "#FFCB45"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5.42661V6.22663C13.4824 6.11163 13.7959 5.97913 14.0625 5.83162V5.08411H13.96C13.7168 5.21161 13.4385 5.32661 13.125 5.42661Z",
    fill: "#FFDF8E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.80656V6.60657C11.5781 6.57157 11.8916 6.52157 12.1875 6.46407V5.66406C11.8916 5.72406 11.5781 5.77156 11.25 5.80656Z",
    fill: "#FFDF8E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 2.2832V3.0832C4.6875 4.18821 6.99609 5.08321 9.84375 5.08321C12.6914 5.08321 15 4.18821 15 3.0832V2.2832H4.6875Z",
    fill: "#FFBA07"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 4.2832C12.6915 4.2832 15 3.38777 15 2.2832C15 1.17863 12.6915 0.283203 9.84375 0.283203C6.99603 0.283203 4.6875 1.17863 4.6875 2.2832C4.6875 3.38777 6.99603 4.2832 9.84375 4.2832Z",
    fill: "#FFCB45"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3.82505V4.62505C13.4824 4.51005 13.7959 4.37755 14.0625 4.23005V3.48254H13.96C13.7168 3.61005 13.4385 3.72505 13.125 3.82505Z",
    fill: "#FFDF8E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.205V5.005C11.5781 4.97 11.8916 4.92 12.1875 4.8625V4.0625C11.8916 4.1225 11.5781 4.17 11.25 4.205Z",
    fill: "#FFDF8E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15723 5.88308C5.00195 5.88308 4.80273 5.87808 4.64453 5.88308V6.27558C4.64453 6.41308 4.66504 6.55308 4.73242 6.68308C4.66504 6.81308 4.68555 6.94558 4.68555 7.08308V7.88308C4.68555 8.02058 4.7207 8.15308 4.78809 8.28308C4.7207 8.41308 4.68555 8.54558 4.68555 8.68308V9.48308C4.68555 10.5881 6.99414 11.5556 9.84179 11.5556C10.3164 11.5556 10.75 11.5281 11.1865 11.4831C11.2129 11.3631 11.248 11.1756 11.248 11.0831V8.68308C11.251 6.84558 8.18652 5.88308 5.15723 5.88308Z",
    fill: "#FDF4EB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.2832V11.0832C0 12.1882 2.30859 13.0832 5.15625 13.0832C8.00391 13.0832 10.3125 12.1882 10.3125 11.0832V10.2832H0Z",
    fill: "#FFBA07"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 12.2832C8.00397 12.2832 10.3125 11.3878 10.3125 10.2832C10.3125 9.17863 8.00397 8.2832 5.15625 8.2832C2.30853 8.2832 0 9.17863 0 10.2832C0 11.3878 2.30853 12.2832 5.15625 12.2832Z",
    fill: "#FFCB45"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 11.8249V12.6249C8.79492 12.5099 9.1084 12.3774 9.375 12.2299V11.4824H9.27246C9.0293 11.6099 8.75098 11.7249 8.4375 11.8249Z",
    fill: "#FFDF8E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 12.203V13.0031C6.89062 12.9681 7.2041 12.9181 7.5 12.8606V12.0605C7.2041 12.1205 6.89062 12.168 6.5625 12.203Z",
    fill: "#FFDF8E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.68359V9.48359C0 10.5886 2.30859 11.4836 5.15625 11.4836C8.00391 11.4836 10.3125 10.5886 10.3125 9.48359V8.68359H0Z",
    fill: "#FFBA07"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 10.6836C8.00397 10.6836 10.3125 9.78816 10.3125 8.68359C10.3125 7.57902 8.00397 6.68359 5.15625 6.68359C2.30853 6.68359 0 7.57902 0 8.68359C0 9.78816 2.30853 10.6836 5.15625 10.6836Z",
    fill: "#FFCB45"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 10.2271V11.0272C8.79492 10.9122 9.1084 10.7797 9.375 10.6321V9.88464H9.27246C9.0293 10.0121 8.75098 10.1271 8.4375 10.2271Z",
    fill: "#FFDF8E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 10.6073V11.4073C6.89062 11.3723 7.2041 11.3223 7.5 11.2648V10.4648C7.2041 10.5248 6.89062 10.5723 6.5625 10.6073Z",
    fill: "#FFDF8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.ed4a1e4c3ee6766c85491939aea26d08.svg";
export { ForwardRef as ReactComponent };